module.exports = __webpack_public_path__ + "static/media/bg.8442d7f2.png";